// RunTrackerForm.tsx
import React from "react";
import StyledButton from "../../components/button";
import StyledInput from "../../components/input";

interface Props {
  runDetails: any;
  setRunDetails: React.Dispatch<React.SetStateAction<any>>;
  onSave: () => void;
}

const RunTrackerForm: React.FC<Props> = ({
  runDetails,
  setRunDetails,
  onSave,
}) => {
  // const handleStravaAuth = () => {
  //   const existingToken = localStorage.getItem("stravaAccessToken");
  //   if (existingToken) {
  //     window.location.href = "/strava-editor";
  //     return;
  //   }
  //   const clientId = "166397";
  //   const redirectUri = window.location.hostname.includes("localhost")
  //     ? "http://localhost:3000/strava"
  //     : "https://jack-pearson.com/strava";
  //   const scope = "activity:read";
  //   window.location.href = `https://www.strava.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&approval_prompt=force&scope=${scope}`;
  // };

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "inline-block",
          marginBottom: "16px",
          marginTop: "8px",
        }}
      >
        <StyledButton
          onClick={() => {}}
          disabled
          style={{ opacity: 0.6, cursor: "not-allowed" }}
        >
          ⬇️ Import Last Run from Strava
        </StyledButton>
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "100%",
            marginLeft: "8px",
            transform: "translateY(-50%)",
            backgroundColor: "#f1f5f9",
            color: "#4b5563",
            fontSize: "0.75rem",
            padding: "2px 6px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          }}
        >
          coming soon
        </span>
      </div>

      {runDetails.distance && (
        <div
          style={{
            marginBottom: "16px",
            fontSize: "14px",
            backgroundColor: "#f6f6f6",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ddd",
          }}
        >
          <strong>Strava Run Imported:</strong>
          <br />
          Distance: {runDetails.distance} km
          <br />
          Pace: {runDetails.paceMinutes}:{runDetails.paceSeconds} /km
          <br />
          Time: {runDetails.timeHours}h {runDetails.timeMinutes}m{" "}
          {runDetails.timeSeconds}s
        </div>
      )}

      <div style={{ marginBottom: "12px" }}>
        <StyledInput
          placeholder="Distance (mi or km)"
          value={runDetails.distance}
          onChange={(e) =>
            setRunDetails({ ...runDetails, distance: e.target.value })
          }
        />
      </div>

      <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
        <StyledInput
          placeholder="Pace Min"
          value={runDetails.paceMinutes}
          onChange={(e) =>
            setRunDetails({ ...runDetails, paceMinutes: e.target.value })
          }
        />
        <StyledInput
          placeholder="Pace Sec"
          value={runDetails.paceSeconds}
          onChange={(e) =>
            setRunDetails({ ...runDetails, paceSeconds: e.target.value })
          }
        />
      </div>

      <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
        <StyledInput
          placeholder="Time Hr"
          value={runDetails.timeHours}
          onChange={(e) =>
            setRunDetails({ ...runDetails, timeHours: e.target.value })
          }
        />
        <StyledInput
          placeholder="Time Min"
          value={runDetails.timeMinutes}
          onChange={(e) =>
            setRunDetails({ ...runDetails, timeMinutes: e.target.value })
          }
        />
        <StyledInput
          placeholder="Time Sec"
          value={runDetails.timeSeconds}
          onChange={(e) =>
            setRunDetails({ ...runDetails, timeSeconds: e.target.value })
          }
        />
      </div>

      <StyledButton onClick={onSave} style={{ width: "100%" }}>
        Log Run
      </StyledButton>
    </>
  );
};

export default RunTrackerForm;
